// extracted by mini-css-extract-plugin
module.exports = {"container":"countryDetail_container__16c30","bandera":"countryDetail_bandera__127Ec","volver":"countryDetail_volver__3CZ61","actividad":"countryDetail_actividad__vriKn"};